
import SelectColumn from "./select"
import Column from "./default"
import CheckboxColumn from "./checkbox"
import MergeColumn from "./merge"
import RowHeader from "./row-header"
import ButtonColumn from "./button"
import IconColumn from "./icon"
import TextareaColumn from "./textarea"

/**
 * 指定されたColumn配列の幅を計算し、各ColumnオブジェクトのactualWidth変数に設定する
 * （widthに文字列で%指定されたものを計算）
 * @param {{import("./common").Context}} ctx
 * @param {Column[]} cols
 * @param {number} defaultColWidth
 * @param {number} defaultColMinWidth
 */
export function calcActualColWidth (ctx, cols, defaultColWidth, defaultColMinWidth) {
	const { absoluteWidthTotal, relativeWidthCols } = cols.reduce((acc, col) => {
		if (typeof col.options.width === "string") {
			acc.relativeWidthCols.push(col)
		} else {
			col.actualWidth = col.options.width || defaultColWidth
			acc.relativeWidthCol += col.actualWidth
		}
		return acc
	}, { absoluteWidthTotal: 0, relativeWidthCols: [] })

	const remainingWidth = ctx.canvas.width - absoluteWidthTotal

	const totalMinWidthOfRelativeCols = relativeWidthCols.reduce((acc, col) => {
		return acc + col.options.minWidth || defaultColMinWidth
	}, 0)

	if (remainingWidth <= totalMinWidthOfRelativeCols) {
		// 相対幅セルに最小幅を設定してもグリッド幅を超える場合は、すべて最小幅を設定
		relativeWidthCols.forEach(col => {
			col.actualWidth = col.options.minWidth || defaultColMinWidth
		})
	} else {
		// 相対幅の計算
		const totalRelativeColsWidth = relativeWidthCols.reduce((acc, col) => {
			const width = col.options.width
			if (width.endsWith("%")) {
				const percentage = Number.parseInt(width.substring(0, -1))

				const actualWidth = Math.floor(percentage / ctx.canvas.width * 100) // TODO ここのfloorの妥当性
				const min = col.options.minWidth || defaultColMinWidth
				acc += col.actualWidth = actualWidth > min ? actualWidth : min
			} else {
				// 一旦、%以外は非対応
				throw new Error(`unsupported width definition. ${col.options.width}`)
			}
			return acc
		}, 0)

		// 相対幅を持つセルの幅が、グリッドをはみ出す場合
		if (totalRelativeColsWidth > remainingWidth) {
			const division = remainingWidth / totalRelativeColsWidth
			relativeWidthCols.forEach(col => {
				const actualWidth = col.actualWidth * division
				const min = col.options.minWidth || defaultColMinWidth
				col.actualWidth = actualWidth > min ? actualWidth : min
			})
		}
	}
}

/**
 *
 * @param {Column} col
 */
export function createColumn (options) {
	switch (options.type) {
	case "select":
		return new SelectColumn({ options: options })
	case "checkbox":
		return new CheckboxColumn({ options: options })
	case "merge":
		return new MergeColumn({ options: options })
	case "row-header":
		return new RowHeader({ options: options })
	case "button":
		return new ButtonColumn({ options: options })
	case "icon":
		return new IconColumn({ options: options })
	case "textarea":
		return new TextareaColumn({ options: options })
	case "number":
		return new Column({ options: options, textboxtCustomEvents: numberEvents(options) })
	default:
	case "text":
		return new Column({ options: options })
	}
}

const numberEvents = option => setValue => ({
	input: e => {
		const el = e.target
		let value = el.value

		if (value === "") {
			return setValue(null)
		}

		const isMinus = value.startsWith("-")
		// if (Number.isNaN(el.valueAsNumber)) {
		// 符号はここで除去される
		value = el.value.replace(/[^\d.]/g, "")
		// }

		if (isMinus) {
			value = `-${value}`
		}

		el.value = value
		setValue(value)
	},
	blur: e => {
		const el = e.target
		let value = el.value

		if (value === "") {
			return setValue(null)
		}

		const isMinus = value.startsWith("-")
		// if (Number.isNaN(el.valueAsNumber)) {
		// 符号はここで除去される
		value = el.value.replace(/[^\d.]/g, "")
		// }
		if (option.numOfIntDigits != null) {
			const [intPart, decimalPart] = value.split(".")
			if (intPart.length > option.numOfIntDigits) {
				value = [intPart.substring(intPart.length - option.numOfIntDigits), decimalPart].filter(Boolean).join(".")
			}
		}

		// 010等になっていたら10にする
		value = Number(value).toString()

		if (option.numOfDecimalPlaces != null) {
			const [intPart, decimalPart] = value.split(".")
			if (decimalPart != null && decimalPart.length > option.numOfDecimalPlaces) {
				value = [intPart, decimalPart.substring(0, option.numOfDecimalPlaces)].join(".")
			} else if (decimalPart != null && decimalPart.length < option.numOfDecimalPlaces) {
				value = [intPart, decimalPart + "0".repeat(option.numOfDecimalPlaces - decimalPart.length)].join(".")
			} else if (decimalPart == null) {
				value = [intPart, "0".repeat(option.numOfDecimalPlaces)].join(".")
			}
		}

		if (isMinus) {
			value = `-${value}`
		} else if (option.hasSign && value) {
			value = `+${value}`
		}

		if (value.endsWith(".")) {
			value = value.substring(0, value.length - 1)
		}

		// 数値でなければクリア
		if (Number.isNaN(Number(value))) {
			value = ""
		}

		el.value = value
		setValue(value)
	}
})
